import { render, staticRenderFns } from "./AnimationMessage.vue?vue&type=template&id=43c95484&scoped=true&"
import script from "./AnimationMessage.vue?vue&type=script&lang=js&"
export * from "./AnimationMessage.vue?vue&type=script&lang=js&"
import style0 from "./AnimationMessage.vue?vue&type=style&index=0&id=43c95484&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c95484",
  null
  
)

export default component.exports